import type { HeroDef } from "../../sim";
import { MANNEQUIN } from "./mannequin";

/** Все герои по id. Новый герой — свой файл, одна строка здесь (GAME-06). */
export const HEROES: ReadonlyMap<string, HeroDef> = new Map([MANNEQUIN].map((hero) => [hero.id, hero]));
